class ConfigProvider {
  constructor () {
    const passportService = {
      passport: {
        endpoint: {
          baseURL: process.env.VUE_APP_PASSPORT_SERVICE_BASE_URL
        },
      }
    }
    const oauth = {
      google: process.env.VUE_APP_OAUTH_GOOGLE_URL,
      facebook: process.env.VUE_APP_OAUTH_FACEBOOK_URL,
      apple: process.env.VUE_APP_OAUTH_APPLE_URL,
      telegram: {
        botName: process.env.VUE_APP_OAUTH_TELEGRAM_BOTNAME,
        redirectUrl: process.env.VUE_APP_OAUTH_TELEGRAM_REDIRECT_URL
      }
    }

    const recaptcha = {
      enabled: process.env.VUE_APP_RECAPTCHA_ENABLED,
      src: process.env.VUE_APP_RECAPTCHA_SRC,
      key: process.env.VUE_APP_RECAPTCHA_KEY
    }

    const jwt = {
      pubKey: process.env.VUE_APP_JWT_PUBKEY
    }

    let roistat
    if (process.env.VUE_APP_ROISTAT_KEY) {
      roistat = {
        key: process.env.VUE_APP_ROISTAT_KEY
      }
    }

    let google
    if (process.env.VUE_APP_GOOGLE_GTAG_ID) {
      google = {
        gtag: {
          id: process.env.VUE_APP_GOOGLE_GTAG_ID
        }
      }
    }

    let pixel
    if (process.env.VUE_APP_PIXEL_ID) {
      pixel = {
        id: process.env.VUE_APP_PIXEL_ID
      }
    }

    let segment
    if (process.env.VUE_APP_SEGMENT_WRITE_KEY) {
      segment = {
        writeKey: process.env.VUE_APP_SEGMENT_WRITE_KEY
      }
    }

    let languages
    if (process.env.VUE_APP_LANGUAGES) {
      languages = process.env.VUE_APP_LANGUAGES.split(",")
    }

    this.appConfig = {
      passportService,
      google,
      oauth,
      roistat,
      pixel,
      segment,
      recaptcha,
      languages,
      jwt
    }
  }

  getConfig () {
    return this.appConfig
  }
}

const instance = new ConfigProvider()
export default instance
